// Discipline tokens that should stay uppercase when humanizing a form key.
const DISCIPLINE_TOKENS = ['PT', 'OT', 'SLP'];

/**
 * Convert a raw form key into a human-readable document title.
 * e.g. `WEEKLY_PROGRESS_NOTE_REFORM_PT` -> `Weekly Progress Note PT`
 *
 * Drops the internal `REFORM` marker, title-cases each word, and keeps the
 * discipline suffix (PT/OT/SLP) uppercase.
 */
export const humanizeFormType = (formType?: string): string => {
  if (!formType) return '';

  return formType
    .split('_')
    .filter((token) => token !== 'REFORM')
    .map((token) =>
      DISCIPLINE_TOKENS.includes(token)
        ? token
        : token.charAt(0) + token.slice(1).toLowerCase()
    )
    .join(' ')
    .trim();
};
